import { Injectable } from '@angular/core';
import { Fridge } from '../interfaces/fridge';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FridgeCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/fridges/' ;
  }

  // Create Fridge
  add(record: Fridge) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Fridge Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Fridges List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Fridge Object
  update(record: Fridge) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Fridge>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Fridge Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
